// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer___2nhzB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.scss
// module id = LeO/
// module chunks = 46